var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.isAnchor ? "a" : "button",
    {
      ref: "button",
      tag: "component",
      staticClass: "ui-icon-button",
      class: _vm.classes,
      style: _vm.buttonColor,
      attrs: {
        "aria-label": _vm.ariaLabel || _vm.tooltip,
        disabled: _vm.disabled || _vm.loading,
        tabindex: "0",
        href: _vm.isAnchor ? (_vm.disabled ? null : _vm.href) : null,
        type: _vm.isAnchor ? null : _vm.buttonType,
      },
      on: { click: _vm.onClick },
    },
    [
      _vm.icon || _vm.$slots.default
        ? _c(
            "div",
            {
              staticClass: "ui-icon-button-icon",
              style: {
                color: !_vm.primaryType ? _vm.$themeTokens.primary : "",
              },
            },
            [
              _vm._t("default", function () {
                return [_c("UiIcon", { attrs: { icon: _vm.icon } })]
              }),
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "ui-icon-button-focus-ring" }),
      _c("KCircularLoader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "keen-ui-icon-button-progress",
        attrs: { size: _vm.size === "large" ? 24 : 18, stroke: 4.5 },
      }),
      _vm.hasDropdown
        ? _c(
            "UiPopover",
            {
              ref: "dropdown",
              attrs: {
                "constain-focus": "",
                "append-to-body": _vm.appendDropdownToBody,
                "constrain-to-scroll-parent":
                  _vm.constrainDropdownToScrollParent,
                position: _vm.dropdownPosition,
                "open-on": _vm.openDropdownOn,
              },
              on: { close: _vm.onDropdownClose, open: _vm.onDropdownOpen },
            },
            [_vm._t("dropdown")],
            2
          )
        : _vm._e(),
      _vm.tooltip
        ? _c(
            "UiTooltip",
            {
              attrs: {
                "open-on": _vm.openTooltipOn,
                position: _vm.tooltipPosition,
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.tooltip) + "\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }